import script from "./PayStubs.vue?vue&type=script&setup=true&lang=js"
export * from "./PayStubs.vue?vue&type=script&setup=true&lang=js"

import "./PayStubs.vue?vue&type=style&index=0&id=32359fcc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32359fcc"]])

export default __exports__